import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_EPOCUS_PROBE_ASSOCIATION_COLLECTION_NAME =
  "epocus-probe-association";

export const useRxCollectionEpocusProbeAssociation =
  (): RxCollection<EpocusProbeAssociation> | null =>
    useRxCollection<EpocusProbeAssociation>(
      RXDB_EPOCUS_PROBE_ASSOCIATION_COLLECTION_NAME,
    );

type UseRxData = Parameters<typeof useRxData<EpocusProbeAssociation>>;
export type EpocusProbeAssociationQueryConstructor = UseRxData["1"];

const EPOCUS_PROBE_ASSOCIATION_SCHEMA_LITERAL = {
  title: "epocus probe association schema",
  version: 2,
  description:
    "Links a device, by probe serial number or by its own AE title, to a performer",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    deviceSerialNumber: {
      type: "string",
      maxLength: 256,
    },
    deviceAeTitle: {
      type: ["string", "null"],
      maxLength: 16,
    },
    performerId: {
      type: "string",
      maxLength: 256,
    },
    performerName: {
      type: "string",
    },
    programId: {
      type: ["string", "null"],
      maxLength: 100,
    },
    meta: SYNCABLE_META,
  },
  required: [
    "id",
    "deviceSerialNumber",
    "performerId",
    "performerName",
    "meta",
  ],
  indexes: [["performerId", "deviceSerialNumber"]],

  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(
  EPOCUS_PROBE_ASSOCIATION_SCHEMA_LITERAL,
);

export type EpocusProbeAssociation = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const EPOCUS_PROBE_ASSOCIATION_SCHEMA: RxJsonSchema<EpocusProbeAssociation> =
  EPOCUS_PROBE_ASSOCIATION_SCHEMA_LITERAL;
